import { Router } from "@remix-run/router";

import { RouteObject, createBrowserRouter } from "react-router-dom";

import RouterErrorBoundary from "@aglocal/web/components/RouterErrorBoundary";

import TalentAssistantApp from "@/pages/TalentAssistantApp";

export const routes: RouteObject[] = [
  {
    path: "/app.html",
    errorElement: <RouterErrorBoundary />,
    element: <TalentAssistantApp />,
  },
  {
    path: "/config.html",
    element: (
      <>
        <h1>Welcome to Talent Assistant</h1>
      </>
    ),
  },
  {
    path: "/remove.html",
    element: (
      <>
        <div>Talent Assistant cannot be removed from this chat.</div>
      </>
    ),
  },
  {
    path: "/",
    index: true,
    element: (
      <>
        <h1>Talent Assistant</h1>
      </>
    ),
  },
];

const router: Router = createBrowserRouter(routes, {
  basename: import.meta.env.BASE_URL,
});

export default router;
